export default "assets/images/texture-bleue-32caa972.jpg";